import React from 'react';
import Axios from 'axios';
import { API_HOST, axiosRequest } from './../../constants/server.constant';
import ReCAPTCHA from "react-google-recaptcha";
import Validate from './../common/validate';



class PartnerCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            email: "",
            usernameEmpty: false,
            usernameError: false,
            emailEmpty: false,
            emailError: false,
            createBox: true,
            isChecked: false

        };
        this.userNameFocus = React.createRef();
        this.emailFocus = React.createRef();
        this.handleInputs = this.handleInputs.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.loadcss = this.loadcss.bind(this);
        this.recaptchaRef = React.createRef();
        this.inputFocus = this.inputFocus.bind(this);


    }
    inputFocus = (event, param) => {
        if(param === "email") {
            if(this.state.username.length <= 0) {
                this.setState({
                    usernameEmpty: true
                });
            }
            if(this.state.username.length > 0) {
                this.setState({
                    usernameEmpty: false
                });
                if(!(Validate("userName", this.state.username))) {
                    this.setState({
                        usernameError: true
                    });
                }
                else {
                    this.setState({
                        usernameError: false
                    });
                }
            }
        }
        if(param === "emailblur") {
            if(this.state.email.length <= 0) {
                this.setState({
                    emailEmpty: true
                });
            }
            if(this.state.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!(Validate("email", this.state.email))) {
                    this.setState({
                        emailError: true
                    });
                }
                else {
                    this.setState({
                        emailError: false
                    });
                }
            }
        }


    };
    componentDidMount() {
        // asyncCall().then(() => this.setState({ loading: true }));
        this.loadcss();
        this.setState({
            showLoader: true
        });
        document.title = "IDrive® Compute | Create Partner";
        document.styleSheets[1].disabled = true;

    }
    componentWillUnmount() {
        document.styleSheets[1].disabled = false;
        var disbale1 = "partner-login.css";
        var disbale2 = "partner-responsive.css";
        Object.values(document.styleSheets).forEach(sheet => {
            let sheetLink = sheet.href;
            if(sheetLink !== null) {
                let urlLastName = sheetLink.split("/").pop();
                let sheetName = urlLastName.split("?");

                if(disbale1.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale2.indexOf(sheetName[0]) > -1) sheet.disabled = true;
            }

        });


    }
    loadcss = () => {
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/partner/include/css/partner-login.css?v=1.0";
        link.rel = "stylesheet";
        link.type = "text/css";
        document.head.appendChild(link);

        const link1 = document.createElement("link");
        link1.href = "https://www.idrivecompute.com/partner/include/css/partner-responsive.css?v=1.0";
        link1.rel = "stylesheet";
        link1.type = "text/css";
        document.head.appendChild(link1);
        setTimeout(() => {
            this.setState({
                showLoader: false
            });
        }, 500);
    };


    handleInputs(event) {
        this.setState({
            sucessMsg: false,
            errorMsg: false
        });
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.setState({
            [name]: val
        });
        if(name === "username") {
            this.setState({
                usernameError: false
            });
            if(val.length > 0) {
                this.setState({
                    usernameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    usernameEmpty: true
                });
            }
        }
        if(name === "email") {
            this.setState({
                emailError: false
            });
            if(val.length > 0) {
                this.setState({
                    emailEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    emailEmpty: true
                });
            }
        }
    }

    onRecaptchaChange = (event) => {

        this.doAuthentication(event);

    };
    doAuthentication(event) {

        this.setState({
            isAction: true
        });

        Axios.post(API_HOST + '/bounty-partner/create?captcha=' + event,
            JSON.stringify({
                partnerName: this.state.username.trim(),
                email: this.state.email.trim(),
                type: this.state.isChecked ? "baremetal" : "cloud"
            })
            , axiosRequest).then(
                (response) => {
                    console.log(response);
                    this.setState({
                        isAction: false
                    });
                    if(response.data === "SUCCESS") {
                        this.setState({
                            createBox: false,
                            errorMsg: false,
                            redirectUrl: "https://www.idrivecompute.com/app/promo/" + this.state.username
                        });
                    }
                    else {
                        this.setState({
                            sucessMsg: false,
                            errorMsg: true
                        });
                    }

                },
                (error) => {
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }
                    this.setState({
                        sucessMsg: false,
                        errorMsg: true,
                        isAction: false
                    });
                }
            );
    }

    submitForm(event) {
        event.preventDefault();
        if(this.state.username.trim().length <= 0) {
            this.setState({
                usernameEmpty: true
            });
            this.userNameFocus.current.focus();

        }
        else if(this.state.email.length <= 0) {
            this.setState({
                emailEmpty: true
            });
            this.emailFocus.current.focus();

        }
        else if(!(Validate("userName", this.state.username))) {
            this.setState({
                usernameError: true
            });
            this.userNameFocus.current.focus();
        }
        else if(!(Validate("email", this.state.email))) {
            this.setState({
                emailError: true
            });
            this.emailFocus.current.focus();
        }
        else {
            this.recaptchaRef.current.execute();
        }
    }


    render() {
        if(this.state.showLoader) {
            return (
                <div class="full_page_loader" style={ { display: this.state.showLoader ? "block" : "none" } }><div class="loader_icon"></div></div>
            );
        }
        return (
            <div className="wraper">
                <div class="full_page_loader" style={ { display: this.state.showLoader ? "block" : "none" } }><div class="loader_icon"></div></div>
                <div class="full_page_loader" style={ { display: this.state.isAction ? "block" : "none" } }><div class="loader_icon"></div></div>
                <div className="wrap_con">
                    <div className="body_con">
                        <div className="loginbox">
                            <div className="logo-section"> <a className="singup-logo" href="https://www.idrivecompute.com/">Logo</a> </div>
                            <div className="login_innerbox" style={ { display: this.state.createBox ? "" : "none" } }>
                                <div className="box_title">Create Partner Login</div>
                                <form onSubmit={ this.submitForm }>
                                    <div class="msg_box" style={ { display: this.state.errorMsg ? "block" : "none" } }>
                                        <div class="common_msg error">
                                            <div class="icon"></div><div class="info">Error while creating partner</div>
                                        </div>
                                    </div>
                                    <div class="msg_box" style={ { display: this.state.sucessMsg ? "block" : "none" } }>
                                        <div class="common_msg success">
                                            <div class="icon"></div><div class="info">Partner Created Sucessfully</div>
                                        </div>
                                    </div>

                                    <div className="intBox">
                                        <label>Partner Name</label>
                                        <input ref={ this.userNameFocus } value={ this.state.username } autoFocus id="nameinput" type="text" name="username" className="inputTxt" autoComplete='off' onChange={ this.handleInputs } ></input>
                                        <i className="email_ico"></i>
                                        { this.state.usernameEmpty ? <span className="error_msg" style={ { display: 'block' } }>Partner name cannot be blank</span> : "" }
                                        { this.state.usernameError ? <span className="error_msg" style={ { display: 'block' } }>Partner name can have a-z 0-9 - _ and atleast four characters</span> : "" }
                                    </div>
                                    <div className="intBox">
                                        <label>Email</label>
                                        <div className="pwd_field_wrap">
                                            <input type="text" value={ this.state.email } ref={ this.emailFocus } name="email" className="inputTxt" onChange={ this.handleInputs } onClick={ (e) => this.inputFocus(e, "email") } onFocus={ (e) => this.inputFocus(e, "email") } onBlur={ (e) => this.inputFocus(e, "emailblur") }></input>
                                            <i className="pswd_ico"></i>

                                        </div>
                                        { this.state.emailEmpty ? <span className="error_msg" style={ { display: "block" } } >Email cannot be blank</span> : "" }
                                        { this.state.emailError ? <span className="error_msg" style={ { display: "block" } } >Email is invalid</span> : "" }
                                    </div>
                                    <div class="intBox">
                                        <label class="checkBox">
                                            <input type="checkbox" name="isChecked" value={ this.state.isChecked } onChange={ this.handleInputs } />
                                            <span class="checkmark"></span>
                                            <p class="add_on_head">Baremetal</p>
                                        </label>
                                    </div>
                                    <div className="partner_btnBlk">
                                        <input type="submit" name="" value="Create" className="loginBtn" data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" onFocus={ (e) => this.inputFocus(e, "submit") }></input>
                                    </div>

                                </form>
                            </div>
                            <div className="forgotbox" style={ { display: this.state.isForgotPassword ? "" : "none" } }>
                                <div className="forgot_innerbox">
                                    <div className="box_title">Forgot Password?</div>
                                    <form onSubmit={ (e) => this.submitForgotForm(e) }>
                                        <div class="msg_box" style={ { display: this.state.forgotPasswordCreds ? "block" : "none" } }>
                                            <div class="common_msg success">
                                                <div class="icon"></div><div class="info">If your email/username exists in our system, you will receive an email with instructions to reset the password.</div>
                                            </div>
                                        </div>
                                        <div class="intBox">
                                            <p class="frget_alert">A link to set a new password for your account will be sent to the email address.</p>
                                            <span class="frget_info">You may need to check your spam folder or add <strong>support@idrive.com</strong> and <strong>support@send.idrive.com</strong> to your contact list to make sure that emails get delivered to your inbox.</span>
                                        </div>
                                        <div className="intBox">
                                            <label for="frget_email">Enter Your Valid Username</label>
                                            <input type="text" ref={ this.forgotEmailFocus } value={ this.state.forgotEmail } name="forgotEmail" className="inputTxt" tabIndex="5" onChange={ this.handleInputs } onBlur={ (e) => this.inputFocus(e, "forgotblur") } />
                                            { this.state.isForgotEmailEmpty ? <span className="error_msg" style={ { display: 'block' } }>Username cannot be blank</span> : "" }
                                        </div>
                                        <div className="intBox" style={ { display: "none" } }>
                                            <div className="lablTxt">Verification Code</div>
                                            <span id="verification"><img src="https://www.idrivecompute.com/partner/include/images/776113556.png" className="ver_img" /></span>
                                            <span>
                                                <input type="text" placeholder="Verification" className="verTxt" maxLength="4" tabIndex="6" />
                                            </span>
                                        </div>
                                        <div className="partner_btnBlk">
                                            <input type="submit" value="Send" className="loginBtn" tabIndex="7" data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" />
                                        </div>

                                        <div className="signin_lnk"><a href="javascript:;" class="backtoLogin" onClick={ () => { this.getForgotBox(false); } }>Back to Login</a> </div>
                                    </form>
                                </div>
                            </div>
                            <div class="login-details" style={ { display: this.state.createBox ? "none" : "" } }>
                                <h3>IDrive Compute Bounty Partner</h3>
                                <ul>
                                    <li>
                                        <span class="login_caption">Partner ID:</span>
                                        <span>{ this.state.username }</span>
                                    </li>
                                    <li>
                                        <span class="login_caption">Email address:</span>
                                        <span>{ this.state.email }</span>
                                    </li>
                                    <li>
                                        <span class="login_caption">Username:</span>
                                        <span>{ this.state.username }</span>
                                    </li>
                                    <li>
                                        <span class="login_caption">Password:</span>
                                        <span>{ this.state.username }</span>
                                    </li>

                                    <li>
                                        <span class="login_caption">Url:</span>
                                        <span><a href={ this.state.redirectUrl } target="_blank">{ this.state.redirectUrl }</a></span>
                                    </li>
                                </ul>
                            </div>
                            <footer>
                                <p className="ftr_txt">&copy; IDrive Inc</p>
                            </footer>
                            <div className="captcha">
                                <ReCAPTCHA
                                    sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                                    onChange={ (e) => this.onRecaptchaChange(e) }
                                    ref={ this.recaptchaRef }
                                    size="invisible"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}

export default PartnerCreate;
